import { render } from "./ManageFailedSubscriptions.vue?vue&type=template&id=2582fe94"
import script from "./ManageFailedSubscriptions.vue?vue&type=script&lang=js"
export * from "./ManageFailedSubscriptions.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__